module.exports = __webpack_public_path__ + "img/banner-1-m.7069e97f.jpg";